import Footer from "../components/footer/Footer";
import Header from "../components/header/Header";
import Breadcrumb from "../components/breadcrumb/Breadcrumb";
import ContactContent from "../components/contact/ContactContent";
import Divider from "../components/divider/Divider";

const Contact = () => {
    return(
        <>
            <Header />
            
            <Breadcrumb 
                breadcrumbTitle="Contact" 
                breadcrumbNav={[
                    {
                        navText: "Home",
                        path: "/home"
                    }
                ]}
            />

            <Divider />
            
            {/* Contact Content */}
            <ContactContent 
            contactTitle="Let's talk about all things!" 
            contactSubTitle="Write to us or give us a call. We will reply to you as soon as possible. But yes, it can take up to 24 hours."
            mapIframeSource="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d26581.378916313336!2d73.01497979884456!3d33.67898479947626!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x38df96f83b6340b1%3A0x8e81a19961c4b08c!2sFAST%20NUCES%20Islamabad%20Campus!5e0!3m2!1sen!2sbd!4v1621528597074!5m2!1sen!2sbd"
            />


            <Divider />

            <Footer />
        </>
    )
}

export default Contact;